import {createAsyncThunk} from '@reduxjs/toolkit'

import {HttpStatusCode} from '@shared/helpers/api'
import {SchemasUniversalDelivery} from '@shared/schemas/universal'

import {getGwErrorMessage} from '@web/helpers/api'

import {OperatorType} from '../constants'

import api from './apis'
import {DeliveryTrackingPayload, OrderDeliveryPayload} from './interfaces'

type PayloadType = {
    orderDelivery?: Maybe<OrderDeliveryPayload>
    deliveryTracking?: Maybe<DeliveryTrackingPayload>
    deliveryReviewWritable?: SchemasUniversalDelivery['/delivery/tracking']['response']['deliveryReviewWritable']
}
type Params = {
    deliveryNo?: string
    productOrderNo?: string
    operatorType: OperatorType
}
export const InitActionError = {
    EMPTY_PARAMS: 'EMPTY_PARAMS',
    EMPTY_RESPONSE: 'EMPTY_RESPONSE',
    API_ERROR: 'API_ERROR',
}

export const initDeliveryTracking = createAsyncThunk<PayloadType, Params>(
    'deliveryTracking/init',
    async ({deliveryNo, productOrderNo, operatorType}, {rejectWithValue}) => {
        if (!deliveryNo || !productOrderNo) {
            return rejectWithValue(InitActionError.EMPTY_PARAMS)
        }

        try {
            const result = await api.getDeliveryTrackingInfo({deliveryNo, productOrderNo, operatorType})

            if (!result.deliveryOrder) {
                return rejectWithValue(InitActionError.EMPTY_RESPONSE)
            }

            return {
                orderDelivery: result.deliveryOrder,
                deliveryTracking: result.deliveryTrace,
                deliveryReviewWritable: result.deliveryReviewWritable,
            }
        } catch (e) {
            // 503 오류인 경우 middleware에서 처리한다.
            if (typeof e === 'string' && getGwErrorMessage(e)?.status === HttpStatusCode.ServiceUnavailable) {
                throw e
            }

            return rejectWithValue(InitActionError.API_ERROR)
        }
    },
)
